import config from 'configDir/index';
import { get } from './http';

// 查询部门/岗位列表(账号新增用)
const getUserByDepartmentService = get('/department/getUserByDepartment', config.userServiceUrl);

// 查询部门/岗位列表
const departmentFindService = get('/department/find', config.userServiceUrl);
// 只查询有账户的部门岗位
const departmentFindWithAccountService = get('/department/find/hasAccount', config.userServiceUrl);

// 按权限查询部门/岗位列表
const getListForAccountService = get('/department/getListForAccount', config.userServiceUrl);

// 查询部门/岗位列表详情
const departmentService = get('/department', config.userServiceUrl);

// 查询部门只查询有人的
const getPositionHasAccountService = get('/department/find/hasAccount', config.userServiceUrl);

export {
  getUserByDepartmentService,
  departmentFindService,
  getListForAccountService,
  departmentService,
  departmentFindWithAccountService,
  getPositionHasAccountService,
};
